<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="keyLogService.showDetailedView"
         [ngStyle]="{width: keyLogService.showDetailedView ? 'calc(100% - 530px)' : '100%'}">
        <div class="ibox-content no-scroll-mode">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Key Log'" [buildings]="keyLogService.buildingsForRead"></filter>
                </div>

                <key-log-filter></key-log-filter>

                <div *ngIf="keyLogService.canEdit()" class="col-sm-3">
                    <button type="button" class="btn btn-w-m btn-primary pull-right"
                            (click)="keyLogService.isKeyLogModalShow = true">
                        <i class="fa fa-plus-circle"></i> New Key
                    </button>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-12">
                    <filters-view></filters-view>
                </div>
            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allKeyLogs'" [ngClass]="{'sk-loading': keyLogService.spinnerShow}">
                    <key-log-list></key-log-list>
                </tab-item>
                <pagination *ngIf="keyLogService.data.allKeyLogs.total && urlService.queryParams['page']"
                            [total]="keyLogService.data['allKeyLogs'].total"></pagination>
                <spinner [spinnerShow]="keyLogService.spinnerShow"></spinner>
            </tabs-wrapper>
        </div>
    </div>


    <div class="animated animated-directory slideInRight detailed-view dv-sidebar" style="width: 510px;">
        <key-log-detailed-view></key-log-detailed-view>
    </div>
</div>

<key-log-modal *ngIf="keyLogService.isKeyLogModalShow"></key-log-modal>
<sign-out-return-key-modal *ngIf="keyLogService.returnKeyModal || keyLogService.signOutKeyModal"></sign-out-return-key-modal>
<key-log-history *ngIf="keyLogService.showHistoryModal"></key-log-history>
<key-log-view *ngIf="keyLogService.isViewModalShow"></key-log-view>



// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log.component.html